import type { Dict } from '../i18n'
import { fill } from './format'

/**
 * The refusals a retry cannot fix: each is about the account selection, and asking again
 * for the same selection gets the same answer. Since GRO-64 the screen can reset the
 * selection to every account of the client, the server's default scope, which it never
 * refuses; that, not a retry, is what the error card offers for these.
 */
export const SHELL_FIXABLE: ReadonlySet<string> = new Set(['mixed_provenance', 'mixed_currency', 'unknown_account'])

/** What to say about a refusal. */
export function errorCopy(load: { message?: string; code?: string; accounts?: string[] }, t: Dict): string {
  const accounts = (load.accounts ?? []).join(', ')
  if (load.code === 'mixed_provenance') return fill(t.errMixedProvenance, { a: accounts })
  if (load.code === 'unknown_audience') return t.errUnknownAudience
  if (load.code === 'mixed_currency') return fill(t.errMixedCurrency, { a: accounts })
  if (load.code === 'unknown_account') return fill(t.errUnknownAccount, { a: accounts })
  if (load.code) return fill(t.errRequest, { c: load.code })
  return load.message ?? ''
}
